import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cns-logo.png'
import _imports_1 from '@/assets/img/icon.jpg'
import _imports_2 from '@/assets/img/logo-48x48.png'
import _imports_3 from '@/assets/img/goby.png'


const _withScopeId = n => (_pushScopeId("data-v-0f13c6b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar p-4",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "logo image is-48x48"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-5 has-text-weight-bold has-text-white" }, "CNS")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "image is-96x96",
  style: {"margin":"auto"}
}, null, -1))
const _hoisted_6 = { class: "has-text-centered is-size-3 my-5 has-text-white has-text-weight-bold" }
const _hoisted_7 = {
  key: 0,
  class: "mb-3 is-size-7 has-text-weight-normal"
}
const _hoisted_8 = { class: "is-flex is-justify-content-center max-w-90" }
const _hoisted_9 = { class: "control has-icons-left search-bar" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-magnify mdi-24px" })
], -1))
const _hoisted_11 = { class: "control" }
const _hoisted_12 = {
  key: 0,
  class: "button is-cns is-loading is-medium"
}
const _hoisted_13 = {
  key: 1,
  class: "is-flex is-justify-content-center mt-4 mx-4 columns is-mobile"
}
const _hoisted_14 = {
  key: 0,
  class: "column is-half-tablet is-5-desktop is-full-mobile"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-size-5 has-text-white mb-4" }, "Result", -1))
const _hoisted_16 = { class: "card mt-4" }
const _hoisted_17 = { class: "card-header" }
const _hoisted_18 = {
  key: 0,
  class: "card-header-title break-all"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-open-in-new" }, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "card-header-title break-all"
}
const _hoisted_22 = ["title"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-storefront mdi-18px mx-1" }, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "royalty-address notification"
}
const _hoisted_25 = { class: "card-content" }
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "is-size-5 has-text-weight-bold" }
const _hoisted_28 = {
  key: 0,
  class: "has-text-warning"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-dots-horizontal-circle mdi-18px" }, null, -1))
const _hoisted_30 = {
  key: 1,
  class: "has-text-info"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-arrow-right-bold-circle mdi-18px" }, null, -1))
const _hoisted_32 = {
  key: 2,
  class: "has-text-success"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-check-circle mdi-18px" }, null, -1))
const _hoisted_34 = {
  key: 3,
  class: "has-text-danger"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-alert-circle mdi-18px" }, null, -1))
const _hoisted_36 = {
  key: 4,
  class: "has-text-danger"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-close-circle mdi-18px" }, null, -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = ["href"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-open-in-new" }, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = { class: "mb-6" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  key: 0,
  class: "field is-horizontal"
}
const _hoisted_46 = { class: "field-body" }
const _hoisted_47 = { class: "field has-addons" }
const _hoisted_48 = { class: "control is-expanded has-icons-left" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-calendar" })
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "button is-static" }, " year(s) ")
], -1))
const _hoisted_51 = { class: "control ml-1" }
const _hoisted_52 = {
  key: 0,
  class: "has-text-danger"
}
const _hoisted_53 = {
  key: 1,
  class: "has-text-danger"
}
const _hoisted_54 = { class: "my-5" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-size-6 has-text-grey" }, "Registration Period", -1))
const _hoisted_56 = { class: "is-pulled-right" }
const _hoisted_57 = { class: "field-body" }
const _hoisted_58 = { class: "field has-addons" }
const _hoisted_59 = { class: "control is-expanded has-icons-left" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-calendar" })
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "button is-static is-small" }, " year(s) ")
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-size-6 has-text-grey" }, "Registration Fee", -1))
const _hoisted_63 = { class: "is-pulled-right" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-size-6 has-text-grey" }, "Annual Fee", -1))
const _hoisted_65 = { class: "is-pulled-right" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-size-6 has-text-grey" }, "Royalty Percentage", -1))
const _hoisted_67 = { class: "is-pulled-right" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-size-6 has-text-grey" }, "Total", -1))
const _hoisted_69 = { class: "is-pulled-right" }
const _hoisted_70 = { class: "has-text-right" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_74 = {
  key: 0,
  class: "modal-card"
}
const _hoisted_75 = { class: "modal-card-head" }
const _hoisted_76 = { class: "modal-card-title" }
const _hoisted_77 = { class: "modal-card-body" }
const _hoisted_78 = { class: "field" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Name", -1))
const _hoisted_80 = { class: "control" }
const _hoisted_81 = ["value"]
const _hoisted_82 = { class: "field" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Address(Optional)", -1))
const _hoisted_84 = {
  key: 1,
  class: "control"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "is-size-7 has-text-grey" }, "If not filled, the owner address will be bound by default.", -1))
const _hoisted_86 = { class: "modal-card-foot is-block" }
const _hoisted_87 = { class: "is-pulled-right" }
const _hoisted_88 = {
  key: 0,
  class: "has-text-color-cns is-size-7 has-text-right"
}
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = {
  key: 1,
  class: "modal-card"
}
const _hoisted_92 = { class: "modal-card-head" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title" }, "Select Registration Method", -1))
const _hoisted_94 = { class: "modal-card-body" }
const _hoisted_95 = { class: "columns is-align-items-start m-3" }
const _hoisted_96 = { class: "column is-7 box has-text-centered mr-6 ml-7" }
const _hoisted_97 = ["href", "download"]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "image is-64x64 is-inline-block ml-4"
}, null, -1))
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "is-size-6 mb-3" }, "CNS Offer File", -1))
const _hoisted_101 = ["href", "download"]
const _hoisted_102 = { class: "mt-5 is-size-5" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "image is-16x16 is-inline-block"
}, null, -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "image is-16x16 is-inline-block"
}, null, -1))
const _hoisted_105 = {
  key: 1,
  target: "_blank",
  href: "https://play.goby.app/takeOffer",
  class: "is-goby-link"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "image is-16x16 is-inline-block"
}, null, -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-5 has-text-grey" }, [
  /*#__PURE__*/_createTextVNode(" (Note: If the wallet doesn't respond, copy the offer into the Pawket wallet, or claim it at "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://play.goby.app/takeOffer",
    class: "underlined_link"
  }, "https://play.goby.app/takeOffer"),
  /*#__PURE__*/_createTextVNode(") ")
], -1))
const _hoisted_108 = /*#__PURE__*/_createStaticVNode("<footer class=\"mt-6 pb-4 px-4 has-text-centered\" data-v-0f13c6b6><a href=\"https://discord.com/invite/uP68PFVWSN\" class=\"has-text-white\" target=\"_blank\" data-v-0f13c6b6>Discord</a><a href=\" https://twitter.com/ChiaNameService\" target=\"_blank\" class=\"has-text-white\" data-v-0f13c6b6> | Twitter</a><a target=\"_blank\" class=\"has-text-white\" href=\"https://sutulabs.github.io/CNSWhitepaper/Faq.html\" data-v-0f13c6b6> | FAQ </a><p class=\"has-text-white\" data-v-0f13c6b6>Trademark is licensed</p></footer>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Ranking = _resolveComponent("Ranking")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", {
        class: "navbar-brand is-clickable",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clear()))
      }, _hoisted_3)
    ]),
    _createElementVNode("div", null, [
      (!_ctx.showDetail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, [
              _createTextVNode(" Chia Name Service "),
              (_ctx.isTestnet)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "testnet"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            class: "input is-medium",
            placeholder: "Search for a Chia Domain Name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
            type: "search",
            maxlength: 63,
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reset())),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.name]
          ]),
          _hoisted_10
        ]),
        _createElementVNode("p", _hoisted_11, [
          (_ctx.isResolving)
            ? (_openBlock(), _createElementBlock("a", _hoisted_12, "Loading"))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "button is-cns is-medium",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.search()))
              }, "Search"))
        ])
      ]),
      (_ctx.showDetail && !_ctx.isResolving)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_ctx.resolveAns)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("header", _hoisted_17, [
                      (_ctx.resolveAns?.status == 'Found')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                            _createElementVNode("a", {
                              class: "has-text-link is-size-5 break-all",
                              href: _ctx.cnsUrl,
                              target: "_blank"
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.cnsName), 1),
                              _hoisted_20
                            ], 8, _hoisted_19)
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.cnsName), 1)),
                      (_ctx.referCode && _ctx.royaltyAddress)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: "has-text-info is-pulled-right mt-2 mx-3",
                            title: _ctx.royaltyAddress,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showRoyalty = !_ctx.showRoyalty))
                          }, [
                            _hoisted_23,
                            _createTextVNode(_toDisplayString(_ctx.referCode), 1)
                          ], 8, _hoisted_22))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.referCode && _ctx.royaltyAddress && _ctx.showRoyalty)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createTextVNode(_toDisplayString(_ctx.royaltyAddress) + " ", 1),
                          _createElementVNode("button", {
                            class: "delete",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showRoyalty = false))
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.cnsName), 1),
                          (_ctx.price.code == 'TooShort')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                _hoisted_29,
                                _createTextVNode("Not Open Yet")
                              ]))
                            : (_ctx.resolveAns?.status == 'Found')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                  _hoisted_31,
                                  _createTextVNode("Registered")
                                ]))
                              : (_ctx.resolveAns?.status == 'NotFound' && _ctx.price.price > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                    _hoisted_33,
                                    _createTextVNode("Available")
                                  ]))
                                : (_ctx.resolveAns.status == 'Failure')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                      _hoisted_35,
                                      _createTextVNode("Network issue")
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                      _hoisted_37,
                                      _createTextVNode("Unavailable")
                                    ]))
                        ]),
                        (_ctx.price.code == 'TooShort')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_38, " During the current operation period of CNS, only names with " + _toDisplayString(_ctx.price.arguments?.[0] ?? _ctx.minLength) + " or more characters can be registered for the time being. In the future, the registration of all names will be gradually opened. Stay tuned! ", 1))
                          : (_ctx.resolveAns?.status == 'Found')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" This name has been registered. Go to view "),
                                _createElementVNode("a", {
                                  class: "has-text-link",
                                  href: _ctx.cnsUrl,
                                  target: "_blank"
                                }, [
                                  _createTextVNode("Profile Homepage"),
                                  _hoisted_40
                                ], 8, _hoisted_39),
                                _createTextVNode(". "),
                                _hoisted_41,
                                _createElementVNode("ul", _hoisted_42, [
                                  (_ctx.resolveAns.expiry)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_43, "Expiry Date: " + _toDisplayString(new Date(_ctx.resolveAns.expiry * 1000).toLocaleDateString()), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.resolveAns.expiry)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_44, "Status: " + _toDisplayString(_ctx.getStatus(_ctx.resolveAns.expiry)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                (!(_ctx.price.price > 0))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                      _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, [
                                          _createElementVNode("p", _hoisted_48, [
                                            _withDirectives(_createElementVNode("input", {
                                              class: "input",
                                              type: "number",
                                              min: "1",
                                              max: "99",
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.regYear) = $event))
                                            }, null, 512), [
                                              [_vModelText, _ctx.regYear]
                                            ]),
                                            _hoisted_49
                                          ]),
                                          _hoisted_50
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("button", {
                                          class: "button is-link",
                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getPrice()))
                                        }, "Renew")
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (_ctx.price.code && _ctx.price.code == 'NameUnavailable')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, "This name is reserved. If you can prove that you are the owner of the name/trademark/brand, please contact us via Twitter/Discord."))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.price.reason), 1))
                              ], 64)),
                        (_ctx.price.price > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createElementVNode("p", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("span", _hoisted_56, [
                                  _createElementVNode("div", _hoisted_57, [
                                    _createElementVNode("div", _hoisted_58, [
                                      _createElementVNode("p", _hoisted_59, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "input is-small",
                                          type: "number",
                                          min: "1",
                                          max: "99",
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.regYear) = $event)),
                                          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getPrice()))
                                        }, null, 544), [
                                          [_vModelText, _ctx.regYear]
                                        ]),
                                        _hoisted_60
                                      ]),
                                      _hoisted_61
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_62,
                                _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.price.registrationFee / 1000000000000) + " " + _toDisplayString(_ctx.unit), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_64,
                                _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.price.annualFee / 1000000000000) + " × " + _toDisplayString(_ctx.price.regYear) + " = " + _toDisplayString((_ctx.price.annualFee * _ctx.price.regYear) / 1000000000000) + " " + _toDisplayString(_ctx.unit), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_66,
                                _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.price.royaltyPercentage / 100) + " %", 1)
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_68,
                                _createElementVNode("span", _hoisted_69, _toDisplayString((_ctx.price.price * (10000 + _ctx.price.royaltyPercentage)) / 10000000000000000) + " " + _toDisplayString(_ctx.unit), 1)
                              ]),
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("button", {
                                  class: "button is-cns",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => {
                        _ctx.showFill = false;
                        _ctx.showModal = true;
                      })
                                }, [
                                  (_ctx.renew)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_71, "Renew"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_72, "Register"))
                                ])
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ modal: true, 'is-active': _ctx.showModal })
    }, [
      _hoisted_73,
      (!_ctx.offer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
            _createElementVNode("header", _hoisted_75, [
              _createElementVNode("p", _hoisted_76, "Register " + _toDisplayString(_ctx.cnsName), 1),
              _createElementVNode("button", {
                class: "delete",
                "aria-label": "close",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showModal = false))
              })
            ]),
            _createElementVNode("section", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _hoisted_79,
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("input", {
                    class: "input",
                    type: "text",
                    disabled: "",
                    value: _ctx.cnsName
                  }, null, 8, _hoisted_81)
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _hoisted_83,
                (!_ctx.showFill)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button is-text",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showFill = true))
                    }, " Click here to specify your bound address, unaffected by owner changes. "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_84, [
                      _hoisted_85,
                      _withDirectives(_createElementVNode("input", {
                        class: "input",
                        type: "text",
                        placeholder: "xch1...",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.address) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.address]
                      ])
                    ]))
              ])
            ]),
            _createElementVNode("footer", _hoisted_86, [
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showModal = false))
              }, "Cancel"),
              _createElementVNode("div", _hoisted_87, [
                (_ctx.registering)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_88, " Please wait a moment while the offer is being generated. "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: _normalizeClass({ button: true, 'is-cns': true, 'is-loading': _ctx.registering }),
                  onKeyup: _cache[16] || (_cache[16] = _withKeys(($event: any) => (_ctx.register()), ["enter"])),
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.register()))
                }, [
                  (_ctx.renew)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_89, "Renew"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_90, "Register"))
                ], 34)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_91, [
            _createElementVNode("header", _hoisted_92, [
              _hoisted_93,
              _createElementVNode("button", {
                class: "delete",
                "aria-label": "close",
                onClick: _cache[18] || (_cache[18] = ($event: any) => {
              _ctx.showModal = false;
              _ctx.address = '';
              _ctx.offer = '';
            })
              })
            ]),
            _createElementVNode("section", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("a", {
                    class: "mr-4 has-text-dark",
                    href: _ctx.offerUri,
                    download: _ctx.cnsName + '.offer',
                    onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
                  }, _hoisted_99, 8, _hoisted_97),
                  _hoisted_100,
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      class: "mr-4 underlined_link bold_link",
                      href: _ctx.offerUri,
                      download: _ctx.cnsName + '.offer',
                      onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                    }, "Download", 8, _hoisted_101),
                    _createElementVNode("a", {
                      class: "underlined_link bold_link",
                      onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.copy(_ctx.offer)), ["stop"]))
                    }, "Copy")
                  ])
                ])
              ]),
              _createElementVNode("p", _hoisted_102, [
                _createTextVNode(" Take the offer by "),
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.openPawket())),
                  class: "is-pawket-link"
                }, [
                  _hoisted_103,
                  _createTextVNode(" Pawket")
                ]),
                _createTextVNode(" or "),
                (_ctx.isGobyExist)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.openGoby())),
                      class: "is-goby-link"
                    }, [
                      _hoisted_104,
                      _createTextVNode(" Goby")
                    ]))
                  : (_openBlock(), _createElementBlock("a", _hoisted_105, [
                      _hoisted_106,
                      _createTextVNode(" Goby")
                    ])),
                _createTextVNode(" wallet. ")
              ]),
              _hoisted_107
            ])
          ]))
    ], 2),
    (!_ctx.showDetail && _ctx.showRanking)
      ? (_openBlock(), _createBlock(_component_Ranking, {
          key: 0,
          class: "mt-12rem"
        }))
      : _createCommentVNode("", true),
    _hoisted_108
  ]))
}